import auth from 'src/router/middleware/authentification/auth.js'

const SickNotesOverview = () => import('src/views/More/SickNotes/SickNotesOverview.vue')

export default [
  {
    path: '/sicknotes/:classbook/overview/:create?',
    component: SickNotesOverview,
    name: 'sick-notes-overview',
    meta: {
      middleware: [auth],
      headerText: 'global.headers.sicknotes',
      requiresCompletedSelfCall: true
    }
  }
]
